<template>
  <div>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <div class="wrapper">
          <div class="wrapper-header">
            <span>
              <a-icon type="wallet" class="margin-right-small" />
              PIPELINE | {{ datasource.pipeline[0].pipeline_no }}
            </span>
            <a-button-group v-if="isMarketing">
              <!-- :disabled="!(isCreator && (datasource.status_besar=='Approved' || datasource.status_besar=='Revised'))" -->
              <a-button @click="handleEdit()"  type="danger" v-if="datasource.pipeline[0] && !isSNExist
              && (datasource.pipeline[0].tlc_create==getAuth.username || isVPM)">
                <a-icon type="edit"/>Edit
              </a-button>
              <a-button v-if="datasource.salesnotif.length<=0" 
                :disabled="!(datasource.pipeline[0].status=='CONTRACT')"
                @click="handleCreateSN" type="primary">
                <a-icon type="plus"/>Create Sales Notif
              </a-button>
            </a-button-group>
          </div>
          <div class="wrapper-body">
            <a-card :bordered="false" :loading="loading.page">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <div class="lbldesc"><b>Create Date :</b></div>
                  <div class="lbldeschead">{{ moment(datasource.pipeline[0].create_dt).format('DD-MM-YYYY') }}</div>
                  <div class="lbldesc"><b>Prospect No :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].no_prospek?datasource.pipeline[0].no_prospek:'-' }}</div>
                  <div class="lbldesc"><b>Product :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].definitions }}</div>
                  <div class="lbldesc"><b>Description :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].description }}</div>
                  <div class="lbldesc"><b>Customer Name :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].client }}</div>
                  <div class="lbldesc"><b>Marketing/IBD :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].pic_am ? datasource.pipeline[0].pic_am : '-' }}</div>
                  <div class="lbldesc"><b>Pimpro :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].pic_pimpro ? datasource.pipeline[0].pic_pimpro : '-' }}</div>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <div class="lbldesc"><b>Contact Detail :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].contact_detail ? datasource.pipeline[0].contact_detail : '-' }}</div>
                  <div class="lbldesc"><b>TLC Create :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].tlc_create }}</div>
                  <!-- <div class="lbldesc"><b>Currency :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].currency }}</div> -->
                  <div class="lbldesc"><b>Est. Contract Value (IDR):</b></div>
                  <div class="lbldeschead">{{ formatCurrency(datasource.pipeline[0].currency,datasource.pipeline[0].est_contract_value).replaceAll('Rp','') }}</div>
                  <div class="lbldesc"><b>Est Operasional Cost (IDR):&nbsp;</b>
                    <!-- <a-button type="danger" size="small" icon="edit"
                      v-if="isCOO"
                      @click="modalEditOperasionalCost = true;modalEditOperasionalCostValue=datasource.pipeline[0].est_operasional_cost">Edit</a-button> -->
                  </div>
                  <div class="lbldeschead">{{ formatCurrency(datasource.pipeline[0].currency,datasource.pipeline[0].est_operasional_cost).replaceAll('Rp','') }}</div>
                  <div class="lbldesc"><b>Est Marketing Cost (IDR):</b></div>
                  <div class="lbldeschead">{{ formatCurrency(datasource.pipeline[0].currency,datasource.pipeline[0].est_marketing_cost).replaceAll('Rp','') }}</div>
                  <div class="lbldesc"><b>Est GA Cost (IDR):</b></div>
                  <div class="lbldeschead">{{ formatCurrency(datasource.pipeline[0].currency,datasource.pipeline[0].est_ga_cost).replaceAll('Rp','') }}</div>
                  <div class="lbldesc"><b>Est Finance Cost (IDR):</b>
                    <!-- <a-button type="danger" size="small" icon="edit"
                      v-if="isVPF"
                      @click="modalEditFinanceCost = true;modalEditFinanceCostValue=datasource.pipeline[0].est_finance_cost">Edit</a-button> -->
                  </div>
                  <div class="lbldeschead">{{ formatCurrency(datasource.pipeline[0].currency,datasource.pipeline[0].est_finance_cost).replaceAll('Rp','') }}</div>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <div class="lbldesc"><b>Status :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].status }}</div>
                  <div v-if="datasource.pipeline[0].status=='PROSPECT'" class="lbldesc"><b>Prospect Progress :</b></div>
                  <div v-if="datasource.pipeline[0].status=='PROSPECT'" class="lbldeschead">
                    {{ datasource.pipeline[0].prospect_progress ? datasource.pipeline[0].prospect_progress: 0 }}%</div>
                  <!-- <div class="lbldesc"><b>Exchange rate :</b></div>
                  <div class="lbldeschead">{{ formatRupiah(datasource.pipeline[0].kurs).replace('Rp','') }}</div> -->
                  <div class="lbldesc"><b>year :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].year }}</div>
                  <div class="lbldesc"><b>Category :</b></div>
                  <div class="lbldeschead">{{ datasource.pipeline[0].kategori }}</div>
                  <div v-if="datasource.salesnotif[0]">
                  <div class="lbldesc"><b>Sales Notification :</b></div>
                    <div class="lbldeschead">{{ datasource.salesnotif[0].no_salesnotif }}</div>
                  </div>
                  <div class="lbldesc"><b>Note :</b></div>
                  <div class="lbldeschead" style="overflow-wrap: anywhere;">{{ datasource.pipeline[0].notes }}</div>
                </a-col>
              </a-row>

              <a-collapse class="margin-top collapseItemManifest" activeKey="1">
                <a-collapse-panel key="1">
                  <div slot="header" class="m-display-flex space-between align-middle">
                    <h4 class="margin-remove">Activity</h4>
                    <div>
                      <a-button :disabled="isNotAllowedAddActivity || triggerCE || isComment || isEdit" type="primary" size="small" icon="plus" class="margin-right"
                        @click="(e)=>{e.stopPropagation();addActivity()}">Add Activity</a-button>
                      <a-button :disabled="isNotAllowedAddActivity || triggerCE || isComment || isEdit" type="default" size="small" class="margin-right" 
                        @click="(e)=>{e.stopPropagation();handleCollapse()}">{{collapse=='active' ? 'Collapse' : 'UnCollapse'}}</a-button>
                    </div>
                  </div>
                  <a-config-provider :locale="getLocalConfigProvider()">
                    <a-list
                      itemLayout="vertical"
                      :dataSource="datasource.activity"
                      class="subListItem"
                    >
                      <a-list-item slot="renderItem" slot-scope="item, index">
                        <a-list-item-meta>
                          <div slot="description">
                            <a-collapse class="margin-top" @change="(e)=>{handleClickHeader(e,index)}" :activeKey="collapse">
                              <a-collapse-panel key="active" :disabled="(isComment || isEdit) && editCommentKey!=item.pipeline_activity_id">
                                <div slot="header" class="collapseItemtitle m-display-flex space-between align-middle">
                                  <div>
                                    <!-- <a-tag color="green">Activity</a-tag> -->
                                    &nbsp;{{ item.description }}
                                  </div>
                                  <div style="margin-right:1rem;">
                                    <a-progress stroke-linecap="square" :percent="Number(item.prospect_progress)" />
                                    <br/>
                                    <span>{{ moment(item.tgl).format("DD-MM-YYYY hh:mm") }} | {{ item.tlc }}</span>
                                    <!-- <a-button icon="message" @click="(e) => { editAsComment(item.pipeline_activity_id,index,e)}" :disabled="isComment || isEdit" shape="circle" class="margin-left"></a-button>&nbsp;
                                    <a-button icon="edit" @click="(e) => { editAsActivity(item,index,e)}" :disabled="item.tlc!=getAuth.username || (item.tlc==getAuth.username && (isComment || isEdit))" shape="circle"></a-button>&nbsp;&nbsp; -->
                                  </div>
                                </div>
                                <div :class="editCommentKey==item.pipeline_activity_id && isComment ? 'commented' : ''" v-if="!(editCommentKey==item.pipeline_activity_id && isEdit)">
                                  <!-- {{ item.label }} -->
                                  <a-table bordered size="small" :rowKey="(record, index) => { return index; }" :pagination="false" :columns="columnsChecklist" :data-source="item.checklist" >
                                    <template slot="prosentase" slot-scope="index, item">
                                      {{item.prosentase}}%
                                    </template>
                                    <template slot="is_cek" slot-scope="index, item">
                                        <a-checkbox v-if="!rerenderChecbox" :key="item.id_pipeline_checklist_dtl" :default-checked="ischecked(item.is_cek)" disabled />
                                    </template>
                                    <template slot="activity" slot-scope="index, item">
                                      {{item.activity}}
                                    </template>
                                  </a-table>
                                  <a-card style="background:#f5f5f5">
                                    <div v-if="item.parent" v-html="'<h3>#<u>'+item.parent[0].description+'</u></h3><br/>'+item.parent[0].activity_note" class="ql-editor commented activityDiv"></div>
                                    <span v-if="item.parent" style="font-style: italic;">{{ item.tlc }} wrote : </span>
                                    <div v-html="item.activity_note" style="max-width: 100%;" class="ql-editor activityDiv"></div>
                                  </a-card>
                                  <div v-if="editCommentKey==item.key && isComment" style="margin: 1rem;">
                                    <i>Write Comment :</i>
                                    <vue-editor v-model="content" class="margin-top"/>
                                    <div style="display: flex;justify-content: flex-end;">
                                      <a-button type="primary" class="margin-top margin-right" @click="handleCreateActivity(item)">{{isComment ? 'Add Comment' : 'Submit Edit'}}</a-button>
                                      <a-button type="danger" class="margin-top" @click="handleCancelActivity()">Cancel</a-button>
                                    </div>
                                  </div>
                                  <div style="display:block;text-align:right" v-if="isMarketing">
                                    <a-button type="link" @click="(e) => { editAsActivity(item,index,e)}" v-if="item.tlc==getAuth.username" :disabled="item.tlc!=getAuth.username || (item.tlc==getAuth.username && (isComment || isEdit))">
                                      <b><i>Edit&nbsp;<a-icon type="edit" /></i></b>
                                    </a-button>
                                    <a-button type="link" @click="(e) => { editAsComment(item.key,index,e)}" class="margin-right:0px!important" v-if="!(isComment || isEdit)">
                                      <b><i>Reply&nbsp;<a-icon type="rollback" /></i></b>
                                    </a-button>
                                  </div>
                                  <span v-if="item.children && item.children.length>0" style="margin-left:1rem"><i>Commented :</i></span>
                                  <a-list
                                    v-if="item.children"
                                    itemLayout="vertical"
                                    :dataSource="item.children"
                                    class="subListItemComment"
                                  >
                                    <a-list-item slot="renderItem" slot-scope="item2, index2" :style="'border-left: solid 2px '+getcolor(item2.tlc)+';'">
                                      <a-list-item-meta>
                                        <div slot="description">
                                          <a-collapse class="margin-top" activeKey="actived">
                                            <a-collapse-panel key="actived" :disabled="(isComment || isEdit) && editCommentKey!=item2.pipeline_activity_id">
                                              <div slot="header" class="collapseItemtitle m-display-flex space-between align-middle">
                                                <!-- <div>
                                                  -- <a-tag>Reply</a-tag>&nbsp; --
                                                  {{ item2.description }}
                                                </div> -->
                                                <div>
                                                  {{ moment(item2.tgl).format("DD-MM-YYYY hh:mm") }} | <span :style="'color:'+getcolor(item2.tlc)">{{ item2.tlc }}</span>
                                                </div>
                                              </div>
                                              <div :class="editCommentKey==item2.pipeline_activity_id && isComment ? 'commented' : ''" v-if="!(editCommentKey==item2.pipeline_activity_id && isEdit)">
                                                <a-card style="background:#f5f5f5">
                                                  <div v-if="item2.parent" v-html="'<h3>#<u>'+item2.parent[0].description+'</u></h3><br/>'+item2.parent[0].activity_note" class="ql-editor commented activityDiv"></div>
                                                  <span v-if="item2.parent" style="font-style: italic;">{{ item2.tlc }} wrote : </span>
                                                  <div v-html="item2.activity_note" style="max-width: 100%;" class="ql-editor activityDiv"></div>
                                                </a-card>
                                              </div>
                                            </a-collapse-panel>
                                          </a-collapse>
                                        </div>
                                      </a-list-item-meta>
                                    </a-list-item>
                                  </a-list>
                                </div>
                              </a-collapse-panel>
                            </a-collapse>
                          </div>
                        </a-list-item-meta>
                      </a-list-item>
                    </a-list>
                  </a-config-provider>
                </a-collapse-panel>
              </a-collapse>
            </a-card>
          </div>

          <a-modal
            v-if="triggerCE"
            :visible="triggerCE"
            :width="getScreen ? '100%' : '80%'"
            @cancel="cancelmodalCE"
            :footer="false"
          >
            <span slot="title">
              Create Activity
              <!-- <a-icon :type="modalCreate.type=='create' ? 'plus' : 'edit'" />&nbsp;{{modalCreate.type=='create' ? 'Create' : 'Edit'}} Pipeline | {{ datasource.pipeline[0].pipeline_no }} -->
            </span>
            <div v-if="triggerCE">
              <div  class="activitiNote">
                <div>
                  <a-form-item label="Prospect Progress (%)" required v-if="this.datasource.pipeline[0].status=='PROSPECT' && (triggerCE || isEdit)">
                    <a-input-number
                      v-model="prospect_progress"
                      disabled
                      :min="0"
                      :max="100"
                    ></a-input-number>
                  </a-form-item>
                  <a-table 
                    :rowKey="(record, index) => { return index; }"
                    bordered size="small" :pagination="false" :columns="columnsChecklist" :data-source="datasource.check_list"
                    :rowClassName="(record, index) => { return record.classrow }"
                    >
                    <template slot="prosentase" slot-scope="index, item">
                      {{item.prosentase}}%
                    </template>
                    <template slot="is_cek" slot-scope="item">
                      <a-spin :spinning="rerenderChecbox" size="small" >
                        <a-checkbox :key="item.id_pipeline_checklist_dtl" :default-checked="ischecked(item.is_cek)" :disabled="item.disabledCheck" v-model="item.checkedBoolean" @click="clickedCheck(item.check_seq)"/>
                      </a-spin>
                    </template>
                    <template slot="activity" slot-scope="index, item">
                      {{item.activity}}
                    </template>
                  </a-table>
                  <a-form-item label="Description Activity" required v-if="triggerCE || isEdit">
                    <a-input
                      autocomplete="off"
                      v-model="desc"
                      :maxLength="255"
                    ></a-input>
                  </a-form-item>
                  <vue-editor v-model="content" class="margin-top"/>
                  <div style="display: flex;justify-content: flex-end;">
                    <a-button type="primary" class="margin-top margin-right" @click="handleCreateActivity({pipeline_activity_id:editCommentKey})">{{isComment ? 'Add Comment' : 'Submit'}}</a-button>
                    <a-button type="danger" class="margin-top" @click="handleCancelActivity()">Cancel</a-button>
                  </div>
                </div>
              </div>
            </div>
          </a-modal>

          <a-modal
            v-if="modalCreate.visible"
            :visible="modalCreate.visible"
            @ok="submitCreateEdit"
            :width="getScreen ? '100%' : '80%'"
            @cancel="cancelmodalcreate"
            ok-text="Submit"
            cancel-text="Cancel"
            :maskClosable="false"
            :confirmLoading="modalCreate.loadingSave"
          >
            <span slot="title">
              <a-icon :type="modalCreate.type=='create' ? 'plus' : 'edit'" />&nbsp;{{modalCreate.type=='create' ? 'Create' : 'Edit'}} Pipeline | {{ datasource.pipeline[0].pipeline_no }}
            </span>
            <a-form :form="formCreateEdit">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-form-item label="Prospect No">
                    <a-select
                      showSearch
                      allowClear
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      v-decorator="['id_prospek', {rules: [{required: false}], initialValue: modalCreate.data.id_prospek}]"
                    >
                      <a-select-option
                          v-for="karyawan in prospectList"
                          :key="karyawan.id_prospek"
                        >[{{karyawan.no_prospek}}] {{karyawan.customer}} - {{karyawan.description}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Id" hidden>
                    <a-input
                      autocomplete="off"
                      v-decorator="['pipeline_id', { rules: [{ required: false }], initialValue: modalCreate.data.pipeline_id}]"
                    ></a-input>
                  </a-form-item>
                  <a-form-item label="Product">
                    <a-input
                      autocomplete="off"
                      v-decorator="['definition', { rules: [{ required: true }], initialValue: modalCreate.data.definition }]"
                    ></a-input>
                  </a-form-item>
                  <a-form-item label="Description">
                    <a-input
                      autocomplete="off"
                      v-decorator="['description', { rules: [{ required: true }], initialValue: modalCreate.data.description }]"
                    ></a-input>
                  </a-form-item>
                  <a-form-item label="Customer Name">
                    <a-auto-complete
                      autocomplete="off"
                      v-decorator="['end_user', { rules: [{ required: true }], initialValue: modalCreate.data.end_user }]"
                      class="certain-category-search"
                      dropdownClassName="certain-category-search-dropdown"
                      :dropdownMatchSelectWidth="false"
                      placeholder="input here"
                      optionLabelProp="value"
                    >
                      <template #dataSource>
                        <a-select-option v-for="cust in datasource.customer" :key="cust.customer_id" :value="cust.customer_nm.trim()">
                          {{ cust.customer_code }} {{ cust.customer_nm }}
                        </a-select-option>
                      </template>
                    </a-auto-complete>
                  </a-form-item>
                  <a-form-item label="Marketing/IBD">
                    <a-select
                      showSearch
                      allowClear
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      v-decorator="['pic', {rules: [{required: true}], initialValue: modalCreate.data.pic}]"
                    >
                      <a-select-option
                          v-for="karyawan in getAllKaryawan"
                          :key="karyawan.tlc"
                        >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="PIMPRO">
                    <a-select
                      showSearch
                      allowClear
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      v-decorator="['pimpro', { rules: [{ required: false }], initialValue: modalCreate.data.pimpro }]"
                    >
                      <a-select-option
                          v-for="karyawan in getAllKaryawan"
                          :key="karyawan.tlc"
                        >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Contact Details">
                    <a-input
                      autocomplete="off"
                      v-decorator="['contact_details', { rules: [{ required: false }], initialValue: modalCreate.data.contact_details }]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-row :gutter="16"  style="display: none">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item label="Currency">
                        <a-select
                          placeholder="Select Currency"
                          v-decorator="['currency', { rules: [{ required: true }], initialValue: modalCreate.data.currency }]"
                          class="width-full"
                          initialValue
                          allowClear
                          @change="handleChangeCurrency"
                        >
                          <a-select-option
                            v-for="item in getAllMataUang"
                            :key="item.code"
                            :value="item.code"
                            >{{ item.code }} - {{ item.currency }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item :label="'Exchange rate'+lblxchangerate">
                        <a-input-number
                          type="number"
                          :min="0"
                          class="m-width-full m-text-align-right"
                          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                          :disabled="lblxchangerate==''"
                          v-decorator="['exchange_rate', { rules: [{ required: true }], initialValue: modalCreate.data.exchange_rate }]"
                        ></a-input-number>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-form-item label="Est. Contract value (IDR)">
                    <a-input-number
                      type="number"
                      :min="0"
                      class="m-width-full m-text-numberRight"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      @change="changeestcontrak"
                      v-decorator="['est_contract_value', { rules: [{ required: true }], initialValue: modalCreate.data.est_contract_value }]"
                    ></a-input-number>
                  </a-form-item>
                  <!-- <a-form-item label="Est. Gross Profit">
                    <div style="display: flex;gap:16px">
                      <a-input-number
                        type="number"
                        :min="0"
                        :max="100"
                        class="m-text-align-right" style="width: 30%;"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                        @keydown="onlyNumber"
                        @change="changeprosen"
                        v-decorator="['est_gross_profit_prosen', { rules: [{ required: true }], initialValue: modalCreate.data.est_gross_profit_prosen }]"
                      ></a-input-number>
                        <a-input-number
                          type="number"
                          :min="0"
                          class="m-text-align-right" style="width: 70%"
                          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                          @keydown="onlyNumber"
                          disabled
                          v-decorator="['est_gross_profit', { rules: [{ required: true }], initialValue: modalCreate.data.est_gross_profit }]"
                        ></a-input-number>
                    </div>
                  </a-form-item> -->
                  <a-form-item label="Est. Operasional Cost (IDR)">
                    <a-input-number
                      type="number"
                      :min="0"
                      class="m-width-full m-text-numberRight"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      
                      v-decorator="['est_operasional_cost', { rules: [{ required: false }], initialValue: modalCreate.data.est_operasional_cost }]"
                    ></a-input-number>
                  </a-form-item>
                  <a-form-item label="Est. Marketing Cost (IDR)">
                    <a-input-number
                      type="number"
                      :min="0"
                      class="m-text-numberRight  m-width-full"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      v-decorator="['est_marketing_cost', { rules: [{ required: true }], initialValue: modalCreate.data.est_marketing_cost }]"
                    ></a-input-number>
                  </a-form-item>
                  <a-form-item label="Est. GA Cost (IDR)">
                    <a-input-number
                      type="number"
                      :min="0"
                      class="m-text-numberRight  m-width-full"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      v-decorator="['est_ga_cost', { rules: [{ required: false }], initialValue: modalCreate.data.est_ga_cost }]"
                    ></a-input-number>
                  </a-form-item>
                  <a-form-item label="Est. Finance Cost (IDR)">
                    <a-input-number
                      type="number"
                      :min="0"
                      class="m-text-numberRight  m-width-full"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      @keydown="onlyNumber"
                      
                      v-decorator="['est_finance_cost', { rules: [{ required: false }], initialValue: modalCreate.data.est_finance_cost }]"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-form-item label="Status">
                    <a-select
                      placeholder="Select "
                      v-decorator="['status', { rules: [{ required: true }], initialValue: modalCreate.data.status }]"
                      class="width-full"
                    >
                      <a-select-option value="PROSPECT">Prospect</a-select-option>
                      <a-select-option value="CONTRACT">Contract</a-select-option>
                      <a-select-option value="LOST">Lost</a-select-option>
                      <a-select-option value="CANCEL">Cancel</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Category">
                    <a-select
                      placeholder="Select Category"
                      v-decorator="['category', { rules: [{ required: true }], initialValue: modalCreate.data.category }]"
                      class="width-full"
                      initialValue
                      allowClear
                    >
                      <a-select-option
                        v-for="item in datasource.kategori"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.text }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Year">
                    <a-select
                      placeholder="Select "
                      v-decorator="['year', { rules: [{ required: true }], initialValue: modalCreate.data.year }]"
                      class="width-full"
                    >
                      <a-select-option :value="moment().format('YYYY')">{{moment().format('YYYY')}}</a-select-option>
                      <a-select-option :value="Number(moment().format('YYYY'))+1">{{Number(moment().format('YYYY'))+1}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- <a-form-item label="Progress">
                    <a-row :gutter="16">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <a-input-number
                          type="number"
                          :min="0"
                          :max="100"
                          class="m-width-full m-text-align-right"
                          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                          @keydown="onlyNumber"
                          @change="changeProgress"
                          ref="refProgress"
                          v-decorator="['progress', { rules: [{ required: true }], initialValue: modalCreate.data.progress }]"
                        ></a-input-number>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
                        <a-progress :percent="modalCreate.progress" />
                      </a-col>
                    </a-row>
                  </a-form-item> -->
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['note', { rules: [{ required: false }], initialValue: modalCreate.data.note }]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-modal>

          <a-modal
            v-if="modalEditFinanceCost"
            :visible="modalEditFinanceCost"
            @cancel="cancelmodalFinanceCost"
            title="Est. Finance Cost Value"
            :footer="false"
          >
            <a-input-number
              type="number"
              :min="0"
              class="m-text-numberRight  m-width-full"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="modalEditFinanceCostValue"
            ></a-input-number>
            <div class="m-display-flex flex-row space-between">
              <span></span>
              <a-button @click="setFinanceCostValue()" type="primary" class="margin-top" :loading="financeCostLoading" icon="save">Submit
              </a-button>
            </div>
          </a-modal>

          <a-modal
            v-if="modalEditOperasionalCost"
            :visible="modalEditOperasionalCost"
            @cancel="cancelmodalOperasionalCost"
            title="Est. Operasional Cost Value"
            :footer="false"
          >
            <a-input-number
              type="number"
              :min="0"
              class="m-text-numberRight  m-width-full"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="modalEditOperasionalCostValue"
            ></a-input-number>
            <div class="m-display-flex flex-row space-between">
              <span></span>
              <a-button @click="setOperasionalCostValue()" type="primary" class="margin-top" :loading="operasionalCostLoading" icon="save">Submit
              </a-button>
            </div>
          </a-modal>
          
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <!-- <Status :status="datasource.status_besar" /> -->
                <a-button
                  @click="historyToggle"
                  type="default"
                  size="small"
                  class="margin-right-small"
                >
                  <a-icon type="clock-circle" />
                </a-button>
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ datasource.pipeline[0] ? datasource.pipeline[0].tlc_create : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ datasource.pipeline[0] ? moment(datasource.pipeline[0].create_dt).format("DD-MM-YYYY") : "" }}</h4>
                  <span class="m-text-small" v-if="datasource.pipeline[0] && datasource.pipeline[0].notes">{{
                    datasource.pipeline[0] ? datasource.pipeline[0].notes : ''
                  }}</span>
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">Created</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                color="green"
                v-for="workflow in datasource.workflow"
                :key="workflow.step_no"
              >
                <div class="m-timeline-title">
                  {{ workflow.actor }} - {{ workflow.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span class="m-text-small" v-if="workflow.remark">{{
                    workflow.remark
                  }}</span>
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Related Document</h4>
            </div>
            <a-list
              itemLayout="horizontal"
              :dataSource="datasource.dokumen_terkait"
            >
              <Empty
                v-if="
                  datasource.dokumen_terkait
                    ? datasource.dokumen_terkait.length <= 0
                    : datasource.dokumen_terkait
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle"
                  >
                    <a @click="handleView(item)"
                      >{{ item.no_trans }} | {{ item.create_by }}</a
                    >
                    <div slot="description">
                      {{ item.deskripsi }}
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>

    <a-card
      :class="getScreen ? 'margin-bottom margin-top' : 'margin-top'"
      v-if="datasource.jenis === 'Approve'"
    >
      <div slot="title">Manifest actions</div>

      <a-form :form="form">
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan_pipeline']"
          />
        </a-form-item>
        <a-form-item label="Action">
          <a-select
            showSearch
            v-decorator="['aksi', { rules: [{ required: true }] }]"
          >
            <a-select-option v-for="item in datasource.aksi" :key="item.aksi">{{
              item.aksi
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleAction"
            block
            type="primary"
            html-type="submit"
            :loading="loading.submitApproval"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-card>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="clock-circle" />&nbsp;History Status </span>

      <ul class="m-list-wrapper">
        <li v-for="history in datasource.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import { forEach } from "lodash";

export default {
  name: "pipeline-manifest",
  props: ["id"],
  mixins: [HandleRoute, GlobalMethod,CurrencyFormat],
  components: {VueEditor},
  data() {
    return {
      content: "",
      loading: {
        page: false,
        submitActivity: false,
        submitApproval: false
      },
      datasource:{
        salesnotif: [],
        customer:[],
        pipeline:[{
        client:"",
        contact_detail:null,
        cost_center_kode:"",
        create_dt:null,
        currency:"",
        definitions:"",
        description:"",
        end_dt:null,
        est_contract_value:"",
        estimate_gross_profit:null,
        kurs:"",
        last_update:null,
        notes:null,
        pic_am:null,
        pic_pimpro:null,
        pipeline_id:"",
        pipeline_no:"",
        progress:null,
        start_dt:null,
        status:"",
        tlc_create:null,
        tlc_update:null,
        up_value:"",
        year:"",

        }]
      },
      lblxchangerate:"",
      triggerCE: false,
      collapse: 'nonactive',
      modalCreate:{
        visible: false,
        type: "",
        loadingSave: false,
        progress: 0,
        data: {
          pipeline_id: null,
          definition: null,
          description: null,
          end_user: null,
          pic: null,
          pimpro: null,
          contact_details: null,
          currency: null,
          exchange_rate: null,
          est_contract_value: null,
          // est_gross_profit: null,
          // est_gross_profit_prosen: null,
          est_operasional_cost: null,
          est_marketing_cost: null,
          est_ga_cost: null,
          est_finance_cost: null,
          status: null,
          category: null,
          year: null,
          progress: null,
          note: null,
        }
      },
      kategori: [],
      desc: "",
      prospect_progress: 0,
      isEdit: false,
      isComment: false,
      editCommentKey:"",
      dataEdit:null,
      modalEditFinanceCost: false,
      modalEditOperasionalCost: false,
      modalEditFinanceCostValue: null,
      modalEditOperasionalCostValue: null,
      financeCostLoading: false,
      operasionalCostLoading: false,
      rerenderChecbox: false,
      classRows:{
        val: '',
        eventOdd: 'OddRows'
      },
      Originalcheck_list: [],
      visibleHistory: false,
      prospectList:[],
      isNotAllowedAddActivity: false
    }
  },
  beforeCreate() {
    this.formCreateEdit = this.$form.createForm(this);
    this.form = this.$form.createForm(this);
  },
  mounted(){
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    this.fetch()
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  computed: {
    ...mapGetters([
    "getAuth",
    "getScreen",
    "getDefaultDateFormat",
    "getStandartFormatDate",
    "getAllMataUang",
    "getAllKaryawan",
    ]),
    isCreator(){
      return this.datasource.pipeline[0].tlc_create == this.getAuth.username
    },
    isMarketing(){
      return this.$route.path.includes('/marketing/pipeline')
    },
    isVPF(){
      return this.$route.path.includes('/vpf/pipeline') || 
      (this.getAuth.nama_bidang && this.getAuth.nama_bidang.filter(item=>item.includes('Vice President Finance')).length>0)
    },
    isVPM(){
      return (this.getAuth.nama_bidang && this.getAuth.nama_bidang.filter(item=>item.includes('Vice President Marketing')).length>0)
    },
    isCOO(){
      return this.getAuth.divisi && this.getAuth.divisi[0] && this.getAuth.divisi[0].toLowerCase()=="chief operation officer" ? true : false;
    },
    columnsChecklist(){
      let sameKey;
      const kolom = [
        {
          title: "Percentage",
          // scopedSlots: { customRender: "prosentase" },
          dataIndex: 'prosentase',
          key: "prosentase",
          width: "120px",
          align: "center",
          customRender: (value, row, index) => {
            const obj = {
              children: value+"%",
              attrs: {},
            };

            let datagroup = _.filter(this.datasource.check_list, item => item.prosentase == value)
            datagroup = _.orderBy(datagroup, function (o) {return new Number(o.check_seq);}, ['asc'])

            let prevdata = _.filter(this.datasource.check_list, item => Number(item.check_seq) == Number(datagroup[0].check_seq)-1)

            // console.log(prevdata[0]?prevdata[0].prosentase:null,value,"----------------",row.check_seq,datagroup[0].check_seq)
            if((prevdata.length==0 && datagroup.length>1 && row.check_seq==datagroup[0].check_seq) || (prevdata[0] && prevdata[0].prosentase!=value && (datagroup[0] && row.check_seq==datagroup[0].check_seq))){
              obj.attrs.rowSpan = datagroup.length
            }else{
              obj.attrs.rowSpan = 0;
            }
            
            // if (index === 0) {
            //   obj.attrs.rowSpan = 2;
            // }
            // if (index === 1) {
            //   obj.attrs.rowSpan = 0;
            // }
            // // These two are merged into above cell
            // if (index === 3) {
            //   obj.attrs.rowSpan = 0;
            // }
            // // if (index === 4) {
            // //   obj.attrs.colSpan = 0;
            // // }
            return obj;
          },
          sorter: (a, b) => a.prosentase - b.prosentase,
        },
        {
          title: "Check",
          scopedSlots: { customRender: "is_cek" },
          key: "is_cek",
          width: "100px",
          align: "center",
          sorter: (a, b) => a.is_cek.length - b.is_cek.length,
        },
        {
          title: "Activity",
          scopedSlots: { customRender: "activity" },
          key: "activity",
          sorter: (a, b) => a.activity.length - b.activity.length,
        },
      ];
      return kolom;
    },
    isSNExist(){
      return this.datasource.salesnotif.length>0
    }
  },
  methods: {
    moment,
    async fetch(){
      this.loading.page = true
      await axios({
        method: "get",
        url: this.$serviceUrl + "pipeline",
        params: {
          pipeline_id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.datasource = response.data

          // if(this.datasource.activity.length>0){
          //   this.triggerCE = true
          // }
          for (let index = 0; index < this.datasource.activity.length; index++) {
            this.datasource.activity[index].collapse = this.collapse
          }
          
          this.Originalcheck_list = this.datasource.check_list

          this.prospectList = response.data.prospek
          this.prospectList.push({
            id_prospek: response.data.pipeline[0].id_prospek,
            no_prospek: response.data.pipeline[0].no_prospek,
            customer: response.data.pipeline[0].prospek_customer,
            description: response.data.pipeline[0].prospek_description,
          })

          if(response.data.status_besar=='CONTRACT'){
            this.isNotAllowedAddActivity = true
          }

          this.loading.page = false
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
          this.loading.page = false
          this.$router.go(-1);
        });
    },
    organizeChecklist(){
      //set class row
      this.datasource.check_list = this.Originalcheck_list
      for (let index = 0; index < this.datasource.check_list.length; index++) {
        this.datasource.check_list[index]['classrow'] = this.getClassRows(this.datasource.check_list[index].prosentase)
      }
      this.classRows.val= ''
      this.classRows.eventOdd= 'OddRows'
    },
    handleCreateSN() {
      this.$router.push({name: "createSalesNotificationfrom",
        params: { sn_id: this.id, cust_id: this.datasource.pipeline[0].client}})
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeCurrency(value){
      if(value=='IDR'){
        this.lblxchangerate = ""
        this.modalCreate.data.exchange_rate = 1
      }else{
        this.lblxchangerate = " to IDR"
      }
    },
    addActivity(){
      this.organizeChecklist()
      this.datasource.check_list.forEach(element => {
        element['checkedBoolean'] = element.is_cek=='1' ? true : false
        element['disabledCheck'] = false
        // element['is_cek'] = '0'
      });
      this.prospect_progress = this.datasource.pipeline[0].prospect_progress ? this.datasource.pipeline[0].prospect_progress : 0
      this.triggerCE = true
    },
    async handleCreateActivity(item){
      if((!this.isComment && (this.desc==null || this.desc=="")) || this.content == ""){
        this.displayMessage("form-warning");
        return 
      }

      this.loading.submitActivity = true
      let url = ""
      let method = ""
      let data = null
      if(this.isEdit){
        url = "pipeline/activity"
        method = "put"

        let lastidchecklist = _.filter(this.datasource.check_list, item => item.is_cek=='1')
        lastidchecklist = lastidchecklist.length>0 ? _.orderBy(lastidchecklist, function (o) {return new Number(o.check_seq);}, ['desc']) : null
        data = {
          pipeline_id: this.datasource.pipeline[0].pipeline_id,
          pipeline_activity_id: this.editCommentKey,
          note: this.content,
          description: this.desc,
          prospect_progress: this.datasource.pipeline[0].status=='CONTRACT' ? 100 : this.prospect_progress,
          id_pipeline_checklist_dtl: lastidchecklist ? lastidchecklist[0].id_pipeline_checklist_dtl : null
        }
      }else if(this.isComment){
        url = "pipeline/activity_comment"
        method = "post"
        data = {
          pipeline_id: this.datasource.pipeline[0].pipeline_id,
          pipeline_activity_id: item.key,
          note: this.content,
          description: this.desc
        }
      }else{
        url = "pipeline/activity"
        method = "post"

        let lastidchecklist = _.filter(this.datasource.check_list, item => item.is_cek=='1')
        lastidchecklist = lastidchecklist.length>0 ? _.orderBy(lastidchecklist, function (o) {return new Number(o.check_seq);}, ['desc']) : null
        data = {
          pipeline_id: this.datasource.pipeline[0].pipeline_id,
          note: this.content,
          description: this.desc,
          prospect_progress: this.datasource.pipeline[0].status=='CONTRACT' ? 100 : this.prospect_progress,
          id_pipeline_checklist_dtl: lastidchecklist ? lastidchecklist[0].id_pipeline_checklist_dtl : null
        }
      }
      await axios({
        method: method,
        url: this.$serviceUrl + url,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then(async (response) => {
          this.rerenderChecbox = true
          this.content = ""
          this.desc=""
          if(response.data.pipeline){
            this.prospect_progress = response.data.pipeline[0].prospect_progress
            this.datasource.pipeline = response.data.pipeline
          }
          if(response.data.check_list){
            this.Originalcheck_list = response.data.check_list
            this.datasource.check_list = this.Originalcheck_list
          }
          this.handleCancelActivity()
          this.datasource.activity = response.data.activity

          this.loading.submitActivity = false
          
          setTimeout(() => {
            this.rerenderChecbox = false
          }, "1000");
          
          if(data.prospect_progress==100)
            await this.fetch();
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
          this.loading.submitActivity = false
          this.$router.go(-1);
        });
    },
    handleResetActivity(){
      this.content = ""
      this.desc=""
      this.prospect_progress = 0
    },
    replacingText(params){
      return params.replaceAll('<img src','<img style="width:100%" src')
    },
    handleEdit(){
      this.modalCreate.data.id_prospek= this.datasource.pipeline[0].id_prospek
      this.modalCreate.data.pipeline_id= this.datasource.pipeline[0].pipeline_id
      this.modalCreate.data.definition = this.datasource.pipeline[0].definitions
      this.modalCreate.data.description = this.datasource.pipeline[0].description
      this.modalCreate.data.end_user = this.datasource.pipeline[0].client
      this.modalCreate.data.pic = this.datasource.pipeline[0].pic_am
      this.modalCreate.data.pimpro = this.datasource.pipeline[0].pic_pimpro
      this.modalCreate.data.contact_details = this.datasource.pipeline[0].contact_detail
      this.modalCreate.data.currency = this.datasource.pipeline[0].currency
      this.modalCreate.data.exchange_rate = this.datasource.pipeline[0].kurs
      this.modalCreate.data.est_contract_value = this.datasource.pipeline[0].est_contract_value
      // this.modalCreate.data.est_gross_profit = this.datasource.pipeline[0].estimate_gross_profit
      // this.modalCreate.data.est_gross_profit_prosen = this.datasource.pipeline[0].estimate_gross_profit_prosen
      this.modalCreate.data.est_operasional_cost = this.datasource.pipeline[0].est_operasional_cost
      this.modalCreate.data.est_marketing_cost = this.datasource.pipeline[0].est_marketing_cost
      this.modalCreate.data.est_ga_cost = this.datasource.pipeline[0].est_ga_cost
      this.modalCreate.data.est_finance_cost = this.datasource.pipeline[0].est_finance_cost
      this.modalCreate.data.status = this.datasource.pipeline[0].status
      this.modalCreate.data.category = this.datasource.pipeline[0].kategori
      this.modalCreate.data.year = this.datasource.pipeline[0].year
      this.modalCreate.data.progress = this.datasource.pipeline[0].progress
      this.modalCreate.progress = this.datasource.pipeline[0].progress ? Number(this.datasource.pipeline[0].progress) : 0
      this.modalCreate.data.note = this.datasource.pipeline[0].notes
      this.modalCreate.type = "edit"
      this.modalCreate.visible = true
    },
    cancelmodalcreate() {
      this.modalCreate.visible = false
    },
    submitCreateEdit() {
      this.formCreateEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
          let formData = new FormData();
          if(values.id_prospek)
            formData.append("id_prospek", values.id_prospek);
          formData.append("pipeline_id", this.datasource.pipeline[0].pipeline_id);
          formData.append("definition", values.definition);
          formData.append("description", values.description);
          formData.append("end_user", values.end_user);
          if(values.pic)
            formData.append("pic", values.pic);
          if(values.pimpro)
            formData.append("pimpro", values.pimpro);
          if(values.contact_details)
            formData.append("contact_details", values.contact_details);
          formData.append("currency", values.currency);
          formData.append("exchange_rate", values.exchange_rate);
          formData.append("est_contract_value", values.est_contract_value);
          // formData.append("est_gross_profit", values.est_gross_profit);
          // formData.append("est_gross_profit_prosen", values.est_gross_profit_prosen);
          formData.append("est_operasional_cost", values.est_operasional_cost);
          formData.append("est_marketing_cost", values.est_marketing_cost);
          formData.append("est_ga_cost", values.est_ga_cost?values.est_ga_cost:0);
          formData.append("est_finance_cost", values.est_finance_cost);
          formData.append("status", values.status);
          formData.append("kategori", values.category);
          formData.append("year", values.year);
          // formData.append("progress", values.progress);
          formData.append("note", values.note ? values.note : "");

          this.modalCreate.loadingSave = true;
          axios({
            method: "post",
            url: this.$serviceUrl + (this.modalCreate.type=='create' ? "pipeline" : "pipeline/edit"),
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then(() => {
              this.modalCreate.loadingSave = false;

              this.formCreateEdit.resetFields();
              this.modalCreate.visible = false;

              if(this.modalCreate.type=='create'){
                this.displayMessage("success-save");
              }else{
                this.displayMessage("success-edit");
              }
              this.fetch();
            })
            .catch((error) => {
              this.modalCreate.loadingSave = false;

              let responses = Object.assign({}, error);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.response.data.message);
              } else {
                this.displayMessageValue("error-other", responses.response);
              }
            });
      });
    },
    changeprosen(val){
      let est_contract_value = this.formCreateEdit.getFieldValue("est_contract_value");
      this.formCreateEdit.setFieldsValue({est_gross_profit:(val/100)*(est_contract_value ? est_contract_value : 0)})
    },
    changeestcontrak(val){
      // let est_gross_profit_prosen = this.formCreateEdit.getFieldValue("est_gross_profit_prosen");
      // this.formCreateEdit.setFieldsValue({est_gross_profit: est_gross_profit_prosen ? (est_gross_profit_prosen/100)*val : 0})
    },
    editAsComment(id,index,e){
      if(this.datasource.activity[index].collapse=='active') e.stopPropagation()
      this.isComment = true
      this.editCommentKey = id
    },
    editAsActivity(item,index,e){
      // console.log("editAsActivity",item)
      // if(this.datasource.activity[index].collapse!='nonactive')
      e.stopPropagation()
      let isdisabledcheck = (item.key == this.datasource.activity[this.datasource.activity.length-1].key ? false : true) || this.datasource.pipeline[0].status=='CONTRACT'
      this.datasource.activity[index].checklist.forEach(element => {
        element.is_cek_origin = element.is_cek
      });
      this.datasource.check_list = [...item.checklist]
      this.datasource.check_list.forEach(element => {
        element.checkedBoolean = element.is_cek=='1' ? true : false
        element.classrow = this.getClassRows(element.prosentase)
        element.disabledCheck = isdisabledcheck
      });
      this.desc = item.description
      this.content = item.activity_note
      this.prospect_progress = this.datasource.pipeline[0].prospect_progress
      this.triggerCE = true
      this.isEdit = true
      this.editCommentKey = item.key
    },
    handleCancelActivity(){
      this.handleResetActivity()

      let idx_act = _.findIndex(this.datasource.activity,
      (e) => {
        return e.key == this.editCommentKey;
      })
      if(idx_act>=0){
        this.datasource.activity[idx_act].checklist.forEach(element => {
          if(element.is_cek_origin){
            element.is_cek = element.is_cek_origin
          }
        });
      } else {
        this.datasource.check_list.forEach(element => {
          element.is_cek =  null
        });
      }
      this.editCommentKey=""
      this.isEdit = false
      this.isComment = false
      this.triggerCE = false
    },
    handleCollapse(){
      this.collapse = (this.collapse=='active' ? 'nonactive' : 'active')
      for (let index = 0; index < this.datasource.activity.length; index++) {
        this.datasource.activity[index].collapse = this.collapse;
      }
    },
    handleClickHeader(e,index){
      this.datasource.activity[index].collapse = (e.length==1 ? 'nonactive' : 'active')
    },
    getcolor(text){
      // console.log("#"+(Math.floor((text.charCodeAt(0)+text.charCodeAt(1)+text.charCodeAt(2))*3).toString(16)).toString())
      return "#"+(Math.floor((text.charCodeAt(0)+text.charCodeAt(1)+text.charCodeAt(2))*10).toString(16)).toString()
    },
    cancelmodalCE(){
      this.handleCancelActivity()
      this.triggerCE = false
    },
    cancelmodalFinanceCost(){
      this.modalEditFinanceCost = false
    },
    cancelmodalOperasionalCost(){
      this.modalEditOperasionalCost = false
    },
    setFinanceCostValue(){
      let formData = new FormData();
      formData.append("pipeline_id", this.datasource.pipeline[0].pipeline_id);
      formData.append("est_finance_cost", this.modalEditFinanceCostValue);
      this.financeCostLoading = true
      axios({
        method: "post",
        url: this.$serviceUrl + "pipeline/edit_vpf",
        processData: false,
        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.datasource.pipeline[0].est_finance_cost = response.data.pipeline[0].est_finance_cost
          this.financeCostLoading = false
          this.modalEditFinanceCost = false
          this.displayMessage("success-edit");
        })
        .catch((error) => {
          this.financeCostLoading = false

          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue("error-other", responses.response.data.message);
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    setOperasionalCostValue(){
      let formData = new FormData();
      formData.append("pipeline_id", this.datasource.pipeline[0].pipeline_id);
      formData.append("est_operasional_cost", this.modalEditOperasionalCostValue);
      this.operasionalCostLoading = true
      axios({
        method: "post",
        url: this.$serviceUrl + "pipeline/edit_coo",
        processData: false,
        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.datasource.pipeline[0].est_operasional_cost = response.data.pipeline[0].est_operasional_cost
          this.operasionalCostLoading = false
          this.modalEditOperasionalCost = false
          this.displayMessage("success-edit");
        })
        .catch((error) => {
          this.operasionalCostLoading = false

          let responses = Object.assign({}, error);
          console.log(responses)
          if (responses.response.data) {
            this.displayMessageValue("error-other", responses.response.data.message);
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    ischecked(value){
      return value=='1' ? true : false
    },
    isdisabledCheck(value){
      let e = _.filter(this.datasource.check_list, item => item.check_seq==value)[0]
      return e.disabledCheck ? e.disabledCheck : false
    },
    clickedCheck(idx){
      this.rerenderChecbox = true
      let selected = _.filter(this.datasource.check_list, item => Number(item.check_seq)==Number(idx))[0]

      this.datasource.check_list.forEach((element) => {
        element.checkedBoolean = (Number(element.check_seq)<=Number(idx) ? (Number(element.check_seq)==Number(idx) ? !selected.checkedBoolean : (element.checkedBoolean ? true : !selected.checkedBoolean)) : false)
        element.is_cek = element.checkedBoolean ? '1' : '0'
      })

      let isemptychecked = (_.filter(this.datasource.check_list, item => item.is_cek=='1')).length>0 ? false : true
      let inpersentage = _.filter(this.datasource.check_list, item => item.prosentase==selected.prosentase)
      let onpersentage = _.filter(this.datasource.check_list, item => item.prosentase==selected.prosentase && item.is_cek=='1')
      inpersentage = _.orderBy(inpersentage, function (o) {return new Number(o.check_seq);}, ['desc'])

      let iscomplete = (onpersentage.length == inpersentage.length)
      
      let nextpercentage = _.filter(this.datasource.check_list, item => Number(item.check_seq)==Number(inpersentage[0].check_seq)+1)
      nextpercentage = nextpercentage.length>0 ? nextpercentage[0].prosentase : null
      
      this.datasource.check_list.forEach((element) => {
        element.disabledCheck = isemptychecked ? false : 
          (Number(element.check_seq)>Number(idx) && (element.prosentase!=selected.prosentase && (iscomplete ? element.prosentase!=nextpercentage : true)) ? true : false)
      });

      // set percentage input
      let prevpercentage = _.filter(this.datasource.check_list, item => Number(item.check_seq)==(Number(idx)-1))
      this.prospect_progress = onpersentage.length>0 ? selected.prosentase : (isemptychecked ? 0 : prevpercentage[0].prosentase)

      this.rerenderChecbox = false
    },
    getClassRows(val){
      if(this.classRows.val != val){
        this.classRows.val = val
        this.classRows.eventOdd = (this.classRows.eventOdd=='EvenRows' ? 'OddRows' : 'EvenRows')
      }
      return this.classRows.eventOdd
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loading.submitApproval = true
        axios({
          method: "post",
          url: this.$serviceUrl + "pipeline/approval ",
          processData: false,
          data: {
            pipeline_id: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan_pipeline ? values.catatan_pipeline : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loading.submitApproval = false
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            this.loading.submitApproval = false
            console.log("error : " + err);
          });
      });
    },
  }
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';

.collapseItemManifest {
  .ant-collapse-item.ant-collapse-item-active{
    .ant-collapse-content.ant-collapse-content-active{
      .ant-collapse-content-box{
        padding: 0px!important;
        .ant-list-item{
          padding: 0px!important;
          .margin-top.ant-collapse.ant-collapse-icon-position-left{
            margin-top:0px!important;
          }
        }
      }
    }
  }
}

.subListItem {
  .ant-list-item-meta {
    margin-bottom: 0px;
    .ant-list-item-meta-content{
      .ant-list-item-meta-description{
        .ant-collapse{
          border: none;
          .ant-collapse-item{
            .ant-collapse-header{
              border: none;
              background: none;
            }
            .ant-collapse-content{
              border: none;
              .ant-collapse-content-box{
                margin: 1rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

img {
  width: 100%;
  max-width: 100%;
}

.lbldesc{
  padding-top: 0.5rem;
  text-transform: uppercase;
}

.lbldeschead{
  margin-left: 1rem;
  padding-top: 0.5rem
}

.commented{
  border-left: solid 3px #e74c3c;
  padding: 1rem;
  background: #e74c3c0d;
}
.activityDiv{
  min-height: auto;
}
</style>
<style lang="less">
.subListItemComment{
  margin-left:1rem;
    & .ant-list-item-meta {
      & .ant-list-item-meta-content {
        & .ant-list-item-meta-description {
          & .ant-collapse {
            & .ant-collapse-item {
              & .ant-collapse-content {
                .ant-collapse-content-box {
                    margin-right: 0px;
                }
              }
            }
          }
        }
      }
    }
}
.m-text-numberRight{
  input{
    text-align: right !important;
    padding-right: 25px;
  }
}

.OddRows{
  background-color: lighten(@color-secondary, 55);
}

.EvenRows{
  background-color: lighten(@color-secondary, 52);
}
</style>